import mock from "../../../fake-db/mock.js"
const data = {
    capture: {
        captures: [
            {
                image: '../../../../images/fond/capture1.jpg'
            },
            {
                image: '../../../../images/fond/capture2.JPG'
            },
            {
                image: '../../../../images/fond/capture3.jpg'
            },
            {
                image: '../../../../images/fond/capture4.jpg'
            },
            {
                image: '../../../../images/fond/capture5.jpg'
            }
        ]
    }
}

mock.onGet("/api/capture/all").reply(() => {
    return [200, data.capture];
});